module.exports = __webpack_public_path__ + "static/img/2areaA_59.27cd6d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/2areaA_59.png
// module id = 804
// module chunks = 1